import { Timeline } from 'element-ui'

const YTimeline = Timeline
YTimeline.$depends = [Timeline]
YTimeline.$name = 'y-timeline'
YTimeline._name = 'Timeline 时间线'

export default YTimeline
